export default __webpack_public_path__ + "static/media/base.5a3002fe.jpg";